module.exports = __webpack_public_path__ + "img/i_homework-partly-checked.8a326ec8.svg";